import de from "./de.json";
import en from "./en.json";
import fr from "./fr.json";
import pt from "./pt.json";

export default { de, en, fr, pt };
